import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.html',
  styleUrls: ['./forgot-password.scss'],
})
// export class ForgotPassword implements OnInit, OnDestroy {
//   username = '';
//   loading = false;

//   private _unsubscribeAll = new Subject<void>();

//   constructor(private _route: ActivatedRoute, private _authServ: AuthService) {}

//   ngOnInit(): void {
//     this._route.queryParams
//       .pipe(takeUntil(this._unsubscribeAll))
//       .subscribe((params) => {
//         this.username = params?.['username'] || '';

//         if (this.username) {
//           this.sendForgotRequest(this.username);
//         }
//       });
//   }

//   sendForgotRequest(username: string) {
//     this.loading = true;

//     this._authServ
//       .forgot(username)
//       .pipe(takeUntil(this._unsubscribeAll))
//       .subscribe({
//         next: () => {
//           this.loading = false;
//         },
//         error: () => {
//           this.loading = false;
//         },
//       });
//   }

//   ngOnDestroy(): void {
//     this._unsubscribeAll.next();
//     this._unsubscribeAll.complete();
//   }
// }
export class ForgotPassword implements OnInit, OnDestroy {
  @Input() username = '';
  @Output() back = new EventEmitter<void>();

  loading = false;
  private _unsubscribeAll = new Subject<void>();

  constructor(private _authServ: AuthService) {}

  ngOnInit(): void {
    if (this.username) {
      this.sendForgotRequest(this.username);
    }
  }

  sendForgotRequest(username: string) {
    this.loading = true;

    this._authServ
      .forgot(username)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: () => (this.loading = false),
        error: () => (this.loading = false),
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
